import { render, staticRenderFns } from "./MiShopRight.vue?vue&type=template&id=0fe44158&scoped=true"
import script from "./MiShopRight.vue?vue&type=script&lang=js"
export * from "./MiShopRight.vue?vue&type=script&lang=js"
import style0 from "./MiShopRight.vue?vue&type=style&index=0&id=0fe44158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe44158",
  null
  
)

export default component.exports